import { useSubscription } from '../../contexts/SubscriptionContext';
import UpgradeOverlay from './UpgradeOverlay';

interface FeatureGateProps {
  feature: string;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

export default function FeatureGate({ feature, fallback, children }: FeatureGateProps) {
  const { hasFeature, isSystemAdmin, loading } = useSubscription();

  // Admins ignoram todos os gates
  if (isSystemAdmin) return <>{children}</>;

  // Durante loading, não mostrar conteúdo premium
  if (loading) return <>{fallback || null}</>;

  // Usuário tem a feature
  if (hasFeature(feature)) return <>{children}</>;

  // Usuário não tem a feature
  if (fallback) return <>{fallback}</>;

  return (
    <UpgradeOverlay feature={feature}>
      {children}
    </UpgradeOverlay>
  );
}
